import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components'
/* Redux imports */
// import {connect} from 'react-redux';
// import {searchActions, searchSelectors} from "../../store/search";
/* styled-component imports */
import {Box, Card, Flex} from "rebass";
import {Input} from "reakit";
/* custom styled-components */
import {SearchButton} from "../Base/Buttons";

const Wrapper = styled(Card)`
z-index: 9100
`;

const ButtonWrapper = styled(Box)`
	min-width: 45px;
	max-width: 45px;
`

const InputWrapper = styled(Box)`
	width: calc(100% - 45px);
	input:focus {
		outline: none;
	}
`




const BasicSearch = (props) => {
	const {search, placeholder, handleInput} = props;

	return (
		<Wrapper bg={'white'} boxShadow={'main'} width={'100%'}>
				<Flex width={1} flexWrap={'wrap'} flexDirection={'row'}>
					<ButtonWrapper >
						<SearchButton type={'submit'}/>
					</ButtonWrapper>
					<InputWrapper>
						<Input onChange={handleInput} value={search} placeholder={placeholder} width={'100%'}/>
					</InputWrapper>
				</Flex>
		</Wrapper>
	);
};

BasicSearch.propTypes = {
	handleInput: PropTypes.func,
	search: PropTypes.string,
	placeholder: PropTypes.string
};

BasicSearch.defaultProps = {
	handleInput: (e) => console.log(e.target.value),
	search: '',
	placeholder: 'Search...'
};

export default BasicSearch;









